import axios from '@/utils/request'
import originaxios from 'axios'
const urlPrefix = 'system'

const api = {
  oss: '/system/oss'
}

// 新建字典
export function addDict (params) {
  return axios({
    url: urlPrefix + '/dict/type/save',
    method: 'POST',
    data: params
  })
}
// 编辑字典
export function editDict (params) {
  return axios({
    url: urlPrefix + '/dict/type/update',
    method: 'PUT',
    data: params
  })
}
// 删除字典
export function deleteDict (ids) {
  return axios({
    url: urlPrefix + '/dict/type/remove?ids=' + ids,
    method: 'DELETE'
  })
}
// 查询字典列表
export function getDictList (params) {
  return axios({
    url: urlPrefix + '/dict/type/page',
    method: 'GET',
    params: params
  })
}
// 新建字典项数据
export function addDictData (params) {
  return axios({
    url: urlPrefix + '/dict/data/save',
    method: 'POST',
    data: params
  })
}
// 查询字典项数据列表
export function getDictDataList (params) {
  return axios({
    url: urlPrefix + '/dict/data/page',
    method: 'GET',
    params: params
  })
}
// 删除字典数据
export function deleteDictData (ids) {
  return axios({
    url: urlPrefix + '/dict/data/remove?ids=' + ids,
    method: 'DELETE'
  })
}
// 编辑字典数据
export function editDictData (params) {
  return axios({
    url: urlPrefix + '/dict/data/update',
    method: 'PUT',
    data: params
  })
}

// oss
export function getOssList (parameter) {
  return axios({
    url: api.oss + '/list',
    method: 'get',
    params: parameter
  })
}
export function saveOss (parameter) {
  return axios({
    url: api.oss + (parameter.id > 0 ? '/update' : '/save'),
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function delOss (parameter) {
  return axios({
    url: api.oss + '/remove',
    method: 'post',
    params: parameter
  })
}
export function getOssConfig () {
  return axios({
    url: api.oss + '/config',
    method: 'get'
  })
}
export function saveOssConfig (parameter) {
  return axios({
    url: api.oss + '/saveConfig',
    method: 'post',
    params: parameter
  })
}

/**
 * 获取上传oss的参数
 * @param data
 * @returns {AxiosPromise}
 */
export function getOssParams (data) {
  return axios({
    url: '/system/oss/make/upload/messages',
    method: 'post',
    data: data
  })
}
/**
 * 上传oss
 */
export async function uploadOss (file, onUploadProgress, onCancelTokenCall) {
  const data = {
    fileName: file.name,
    contentType: file.type
  }
  const res = await getOssParams(data)
  if (res.code === 200) {
    // return axios({
    //   url: res.data.uploadUrl,
    //   method: 'put',
    //   data: file,
    //   timeout: 200000,
    //   headers: {
    //     'Content-Type': file.type
    //   }
    // })
    // 取消上传
    var ss = originaxios.CancelToken.source()
    if (onCancelTokenCall) {
      onCancelTokenCall(ss)
    }
    return new Promise((resolve, reject) => {
      axios({
        url: res.data.uploadUrl,
        method: 'put',
        data: file,
        timeout: 200000,
        headers: {
          'Content-Type': file.type
        },
        onUploadProgress: progressEvent => {
          if (onUploadProgress) {
            onUploadProgress(progressEvent.loaded, progressEvent.total)
          }
        },
        cancelToken: ss.token
      }).then(() => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

/**
 * 获取短信验证码
 * @param {*} parameter
 * @returns
 */
export function getSmsCaptcha (data) {
  return axios({
    // url: urlloginPrefix + '/publics/message/{type}/code',
    url: `/platform/publics/message/${data.type}/code`,
    method: 'post',
    data: data
  })
}

// 操作日志--分页查询
export function operationList (params) {
  return axios({
    url: urlPrefix + '/operateLog/page',
    method: 'GET',
    params: params
  })
}
// 操作日志--单个消息通知已读
export function operateLogRead (data) {
  return axios({
    url: urlPrefix + '/operateLog/read',
    method: 'post',
    data
  })
}
// 操作日志--全部已读
export function operateLogReadAll () {
  return axios({
    url: urlPrefix + '/operateLog/readAll',
    method: 'post'
  })
}
// 操作日志--是否存在未读1-存在，0-不存在
export function operateLogState () {
  return axios({
    url: urlPrefix + '/operateLog/state',
    method: 'get'
  })
}

// 版本更新--分页查询
export function versionList (params) {
  return axios({
    url: urlPrefix + '/version/page',
    method: 'GET',
    params: params
  })
}
// 版本更新--消息是否已读
export function readState (data) {
  return axios({
    url: urlPrefix + '/version/read',
    method: 'post',
    data
  })
}
// 版本更新--是否存在未读1-存在，0-不存在
export function existRead () {
  return axios({
    url: urlPrefix + '/version/state',
    method: 'get'
  })
}
